export default __webpack_public_path__ + "static/media/visa-electron.8b5185c1.svg";